import { render, staticRenderFns } from "./ViewLive.vue?vue&type=template&id=7bcd2622&scoped=true&"
import script from "./ViewLive.vue?vue&type=script&lang=ts&"
export * from "./ViewLive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd2622",
  null
  
)

export default component.exports